import { render, staticRenderFns } from "./DirectoryDatasetPicker.vue?vue&type=template&id=3904222f&scoped=true"
import script from "./DirectoryDatasetPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectoryDatasetPicker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DirectoryDatasetPicker.vue?vue&type=style&index=0&id=3904222f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904222f",
  null
  
)

export default component.exports